// @flow

export const WS_GET_USER_DATA_FROM_FC_REQUEST = 'WS_GET_USER_DATA_FROM_FC_REQUEST';
export const WS_GET_USER_DATA_FROM_FC_SUCCESS = 'WS_GET_USER_DATA_FROM_FC_SUCCESS';
export const WS_GET_USER_DATA_FROM_FC_FAILURE = 'WS_GET_USER_DATA_FROM_FC_FAILURE';
export const CLEAR_FC_DATA = 'CLEAR_FC_DATA';
